import { useEffect, useState } from "react";
import { fetchIdeas } from "../../lib/ideas";
import { Reveal, SectionHead } from "./Reveal";
import { IdeaCard } from "./IdeaCard";
import { SuggestForm } from "./SuggestForm";

const tabs = [["team", "From the team"], ["community", "Community ideas"]];
const sorts = [["top", "Top"], ["new", "New"]];

const sortIdeas = (list, sort) =>
  [...list].sort((a, b) => sort === "top"
    ? ((b.up || 0) - (b.down || 0)) - ((a.up || 0) - (a.down || 0)) || (b.created_at > a.created_at ? 1 : -1)
    : (b.created_at > a.created_at ? 1 : -1));

const Pill = ({ active, onClick, children, testid }) => (
  <button onClick={onClick} data-testid={testid}
    className={`rounded-full px-4 py-2 font-mono text-xs uppercase tracking-[0.15em] transition-colors ${active ? "bg-[#00E5FF] text-[#050911] font-bold" : "border border-cyan-400/20 text-slate-300 hover:text-white hover:border-cyan-400/50"}`}>
    {children}
  </button>
);

export const Ideas = () => {
  const [tab, setTab] = useState("team");
  const [sort, setSort] = useState("top");
  const [ideas, setIdeas] = useState({ team: [], community: [] });

  useEffect(() => {
    Promise.all([fetchIdeas("team"), fetchIdeas("community")]).then(([team, community]) => setIdeas({ team, community }));
  }, []);

  const update = (it) => setIdeas((s) => ({ ...s, [it.source]: s[it.source].map((x) => (x.id === it.id ? { ...x, ...it } : x)) }));
  const add = (it) => setIdeas((s) => ({ ...s, community: [it, ...s.community] }));
  const list = sortIdeas(ideas[tab], sort);

  return (
    <section id="ideas" className="relative border-t border-cyan-400/10 py-24 sm:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead over="// 03 — You decide" title={<>Vote on<br />what's next<span className="text-[#00E5FF]">.</span></>}
          sub="Tell us what you want in Angler League. Vote on ideas from the team, or pitch your own and let other anglers vote." />
        <Reveal className="mb-8 flex flex-wrap items-center justify-between gap-3">
          <div className="flex flex-wrap gap-2">
            {tabs.map(([k, l]) => <Pill key={k} active={tab === k} onClick={() => setTab(k)} testid={`ideas-tab-${k}`}>{l} ({ideas[k].length})</Pill>)}
          </div>
          <div className="flex gap-2">
            {sorts.map(([k, l]) => <Pill key={k} active={sort === k} onClick={() => setSort(k)} testid={`ideas-sort-${k}`}>{l}</Pill>)}
          </div>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {tab === "community" && <div className="md:col-span-2 lg:col-span-1"><SuggestForm onAdded={add} /></div>}
          {list.map((it, i) => <IdeaCard key={it.id} idea={it} i={i} onChange={update} />)}
          {list.length === 0 && (
            <p data-testid="ideas-empty" className="rounded-3xl border border-dashed border-cyan-400/20 p-8 font-mono text-sm text-slate-400">
              {tab === "team" ? "No team ideas yet — check back soon." : "No community ideas yet. Be the first to pitch one."}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};
